"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openQuestionFiftyFiftyMirroredLayout = exports.openQuestionFiftyFiftyLayout = exports.openQuestionTitleOnlyLayout = void 0;
const helpers_1 = require("../helpers");
const tip_tap_1 = require("../tip-tap");
function openQuestionTitleOnlyLayout({ question = helpers_1.fallbackCopy['openQuestion.title'], backgroundColor = '#D2D1FF', backgroundImage, }) {
    return {
        key: 'TITLE_ONLY',
        backgroundColor,
        backgroundImage,
        layoutParts: {
            TITLE: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(32, 32),
                size: (0, helpers_1.newSize)(896, 60),
                content: (0, tip_tap_1.stringToProsemirror)(question, {
                    bold: true,
                }),
                order: 'a0',
                settings: {
                    fontFamily: 'Plus Jakarta Sans',
                    fontSize: '32px',
                    textStyleKey: 'TITLE',
                    horizontalAlignment: 'center',
                },
            }),
            ANSWER_AREA: (0, helpers_1.newAnswerAreaPinComponent)({
                order: 'a1',
            }),
        },
        pinComponents: [],
    };
}
exports.openQuestionTitleOnlyLayout = openQuestionTitleOnlyLayout;
function openQuestionFiftyFiftyLayout({ question = helpers_1.fallbackCopy['openQuestion.title'], backgroundColor = '#D2D1FF', backgroundImage, imageOverride, }) {
    return {
        key: 'FIFTY_FIFTY',
        backgroundColor,
        backgroundImage,
        layoutParts: {
            TITLE: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(32, 32),
                size: (0, helpers_1.newSize)(432, 222),
                content: (0, tip_tap_1.stringToProsemirror)(question, {
                    bold: true,
                }),
                order: 'a0',
                settings: {
                    fontFamily: 'Plus Jakarta Sans',
                    fontSize: '32px',
                    textStyleKey: 'TITLE',
                    horizontalAlignment: 'center',
                },
            }),
            ...(imageOverride !== 'no-image' && {
                IMAGE1: imageOverride ||
                    (0, helpers_1.newImagePinComponent)({
                        position: (0, helpers_1.newVector)(32, 286),
                        size: (0, helpers_1.newSize)(432, 222),
                        order: 'a1',
                    }),
            }),
            ANSWER_AREA: (0, helpers_1.newAnswerAreaPinComponent)({
                position: (0, helpers_1.newVector)(496, 32),
                size: (0, helpers_1.newSize)(432, 476),
                order: 'a2',
            }),
        },
        pinComponents: [],
    };
}
exports.openQuestionFiftyFiftyLayout = openQuestionFiftyFiftyLayout;
function openQuestionFiftyFiftyMirroredLayout({ question = helpers_1.fallbackCopy['openQuestion.title'], backgroundColor = '#D2D1FF', backgroundImage, imageOverride, }) {
    return {
        key: 'FIFTY_FIFTY',
        backgroundColor,
        backgroundImage,
        layoutParts: {
            TITLE: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(496, 32),
                size: (0, helpers_1.newSize)(432, 222),
                content: (0, tip_tap_1.stringToProsemirror)(question, {
                    bold: true,
                }),
                order: 'a0',
                settings: {
                    fontFamily: 'Plus Jakarta Sans',
                    fontSize: '32px',
                    textStyleKey: 'TITLE',
                    horizontalAlignment: 'center',
                },
            }),
            ...(imageOverride !== 'no-image' && {
                IMAGE1: imageOverride ||
                    (0, helpers_1.newImagePinComponent)({
                        position: (0, helpers_1.newVector)(496, 286),
                        size: (0, helpers_1.newSize)(432, 222),
                        order: 'a1',
                    }),
            }),
            ANSWER_AREA: (0, helpers_1.newAnswerAreaPinComponent)({
                position: (0, helpers_1.newVector)(32, 32),
                size: (0, helpers_1.newSize)(432, 476),
                order: 'a2',
            }),
        },
        pinComponents: [],
    };
}
exports.openQuestionFiftyFiftyMirroredLayout = openQuestionFiftyFiftyMirroredLayout;
//# sourceMappingURL=open-question-templates.js.map